<template>
  <div>
    <loader v-if="settings === null" />
    <div v-else>
      <div class="flex flex-col md:flex-row mb-4">
        <div class="mb-4 md:mb-0 md:mr-6">
          <label class="label-xs">Send Notifications To</label>
          <input
            v-model="settings.recipient_email"
            class="rounded input w-full"
            :class="{ 'border-red-dark': errors.get('recipient_email') }"
          />
        </div>

        <div class="mb-4 md:mb-0 md:mr-6">
          <label class="label-xs">CC Notifications Email address</label>
          <input v-model="settings.cc_email" class="rounded input w-full"  />
        </div>

        <div class="mb-4 md:mb-0 md:mr-6">
          <label class="label-xs">Professional Valuation Requests to</label>
          <input v-model="settings.cc_pro_email" class="rounded input w-full"  />
        </div>
      </div>

      <div class="flex flex-col md:flex-row mb-4">
        <div class="mb-4 md:mb-0 md:mr-3">
          <label class="label-xs">Send Notifications </label>
          <pl-select class="w-full" v-model="settings.instant_non_pro_email">
            <option value="YES">Send a notification as soon as a valuation has been created</option>
            <option value="NO">Batch the notifications into hourly updates</option>
          </pl-select>
        </div>

        <div class="mb-4 md:mb-0 md:mr-3">
          <label class="label-xs">Receipient Settings</label>
          <pl-select class="w-full" v-model="settings.send_to_offices">
            <option value="YES">Send e-mails to the correct office based on their assigned postcode areas. Fallback to the address provided above</option>
            <option value="NO">Send all e-mails to the address provided above</option>
          </pl-select>
        </div>
      </div>

      <div class="flex flex-col md:flex-row mb-4">
        <div class="mb-4 md:mb-0 md:mr-6">
          <label class="label-xs">Module Colour</label>
          <div class="rounded w-full input flex items-center">
            <input
              v-model="settings.colour"
              type="text"
              class="h-full w-full bg-transparent"
              :class="{ 'border-red-dark': errors.get('colour') }"
            />
            <input type="color" v-model="settings.colour" class="h-6 w-6 border-0 bg-transparent" />
          </div>
        </div>

        <div class="mb-4 md:mb-0 md:mr-6">
          <label class="label-xs">Display form in</label>
          <pl-select class="w-full" v-model="settings.split_form">
            <option value="NO">Present as one stage</option>
            <option value="YES">Present as two stages</option>
          </pl-select>
        </div>

        <div class="mb-4 md:mb-0 md:mr-6">
          <label class="label-xs">Department to show:</label>
          <pl-select class="w-full" v-model="settings.department">
            <option value="BOTH">Sales and Lettings</option>
            <option value="RS">Sales Only</option>
            <option value="RL">Lettings Only</option>
          </pl-select>
        </div>

        <div class="mb-4 md:mb-0 md:mr-6">
          <label class="label-xs">Bookings Calendar</label>
          <pl-select class="w-full" v-model="settings.engage_calendar">
            <option value="YES">Yes</option>
            <option value="NO">No</option>
          </pl-select>
        </div>

        <div class="mb-4 md:mb-0 md:mr-6">
          <label class="label-xs">Custom Disclamier &amp; Image</label>
          <pl-select class="w-full" v-model="settings.custom_toggle">
            <option value="NO">Hide</option>
            <option value="YES">Show</option>
          </pl-select>
        </div>
      </div>

      <div class="flex flex-col md:flex-row flex-wrap mb-4">
        <div class="mb-4 md:mb-0 md:mr-6">
          <label class="label-xs">Valuation Margin Percentage</label>
          <input v-model="settings.lower_upper_margin" class="rounded input w-full" />
        </div>

        <div class="mb-4 md:mb-0 md:mr-6">
          <label class="label-xs">Rental Yield Percentage</label>
          <input v-model="settings.rental_yield" class="rounded input w-full" />
        </div>
      </div>

      <div class="w-full flex flex-col flex-wrap">
        <div class="w-full mb-5">
          <label class="label-xs">Custom Disclaimer</label>
          <tinymce
            :init="editorConfig"
            v-model="settings.custom_disclaimer"
          />
        </div>

        <div class="w-full mb-5">
          <label class="label-xs">Custom HTML</label>
          <textarea v-model="settings.custom_html" class="w-full input rounded"></textarea>
        </div>
      </div>
      <button
        class="bg-secondary text-white rounded px-6 py-2 w-1/2 md:w-1/6"
        :class="{ 'opacity-75': saving }"
        :disabled="saving"
        @click="saveSettings"
      >
        {{ saving ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </div>
</template>

<script>
import api from '@/http'
import ErrorBag from '@/ErrorBag'
import mceConfig from '@/mixins/TinyMCE'
import { mapState, mapActions } from 'vuex'

export default {
  mixins: [ mceConfig ],

  data () {
    return {
      errors: new ErrorBag(),
      saving: false,
      settings: null
    }
  },

  created () {
    this.fetchSettings()
  },

  computed: {
    ...mapState(['selectedOffice'])
  },

  methods: {
    ...mapActions(['displayToastNotification']),

    fetchSettings () {
      api.get('/evaluate/settings', {
        params: {
          officeID: this.selectedOffice.id
        }
      }).then(({ data }) => {
        this.settings = data
      })
    },

    saveSettings () {
      this.saving = true
      api.post('/evaluate/settings', {
        ...this.settings,
        officeID: this.selectedOffice.id
      }).then(({ data }) => {
        this.saving = false
        this.settings = data
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Saved',
          info: 'Your module settings have been saved successfully'
        })
      }).catch(({ response }) => {
        this.saving = false
        this.errors.store(response.data)
      })
    }
  }
}
</script>
